/* eslint-disable vue/no-v-html */
<!--
 * @LastEditors: wangke
-->
<template>
  <div
    class="data"
    :class="isMargin?'haveMargin':''"
  >
    <div
      v-if="
        iscataloglist"
      class="ifmBox"
    >
      <!-- <span v-if="cataloglist">
          {{ cataloglist.contentText }}
        </span> -->
      <div
        v-if="cataloglist.type == 0"
        ref="refContent"
        class="ifmContent"
        @click="imageEnlargement"
        v-html="cataloglist.htm"
      />
      <div
        v-if="cataloglist.type == 1"
        class="ifmebox"
      >
        <iframe
          :src="cataloglist.url"
          frameborder="0"
          class="ifme"
        />
      </div>
      <!-- 列表进入 视频 -->
      <div
        v-if="cataloglist.type == 2"
        class="imgbox"
      >
        <img
          :src="cataloglist.VideoImage"
          alt=""
          class="videoImg"
        >
        <img
          class="play_icon"
          src="../../../assets/icon/icon_play.png"
          alt=""
          @click="showBox = true"
        >
      </div>
    </div>

    <div
      v-if="html && !siteStatus"
      ref="refContent"
      class="htmlBox"
      @click="imageEnlargement"
      v-html="html"
    />
    <div
      v-if="isvideo"
      class="videoBox"
    >
      <video
        x5-playsinline=""
        webkit-playsinline="true"
        playsinline="true"
        :src="videoUrl"
        :poster="poster"
        controls="controls"
      />
    </div>
    <div
      v-if="url"
      class="ifmBox"
    >
      <iframe
        :src="url"
        frameborder="0"
        class="ifme"
      />
    </div>
    <div
      v-if="siteStatus"
      class="nodata"
    >
      <img
        class="nodata_img"
        style="height:195px"
        src="../../../assets/image/icon_data_delete.png"
        alt=""
      >
      <span class="nodata_text"> 该内容已被禁用，暂无法预览</span>
    </div>
    <div
      v-if="dataDtl"
      class="nodata"
    >
      <img
        class="nodata_img"
        style="height:195px"
        src="../../../assets/image/icon_data_delete.png"
        alt=""
      >
      <span class="nodata_text2">你访问的内容已被下架，暂无法浏览</span>
    </div>
    <div
      v-if="showBox"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
      "
      class="theVideoStratum"
    >
      <div
        style="width: 100%; height: 100%; background-color: rgba(0, 0, 0)"
        class="closeTheVideo"
        @click="cls"
      />
      <div class="theVideoStratumBox">
        <video
          ref="myVideo"
          :src="videoUrl"
          autoplay="autoplay"
          controls="controls"
          class="vdo"
        />
      </div>
    </div>
    <lebals
      :showqq="showqq"
      :showdz="showdz"
    />
    <viewer
      ref="viewer"
      :images="photo"
      :index="1"
      @inited="inited"
    >
      <img
        v-for="(src,index) in photo"
        :key="index"
        style="display: none;"
        :src="src"
      >
    </viewer>
  </div>
</template>

<script>
import api from './proxy';
import lebals from './lebals';
import { removeWatermark, setWaterMark } from '../../../lib/watermark';
export default {
    components: {
        lebals,
    },
    data () {
        return {
            showqq: false,
            showdz: false,
            iscataloglist: false,
            contentIndex: null,
            catalogId: null,
            cataloglist: {
                type: null,
                url: null,
                htm: null,
                videoUrl: null,
                VideoImage: null,
            },
            url: null,
            html: null,
            videoUrl: null,
            poster: null,
            showBox: false,
            isvideo: false,
            siteStatus: false,
            dataDtl: false,
            urlList: null,
            isMargin: false,
            photo: [],
        };
    },
    created () {
        // if (this.IsPC()) {
        //     this.$router.replace({ name: 'mobileBoxContent', query: this.$route.query });
        // }
        let contentId = this.$route.query.contentId;
        let url = this.$route.query.url;
        // 判断是否为url进入
        if (contentId) {
            console.log('地址栏');
            this.getInfoCintent(contentId);
        } else if (url !== null && url !== undefined) {
            // 判断是否为iframe显示
            console.log('预览进入');
            this.url = url;
        } else {
            // 是否为列表进入
            console.log('列表进入');
            this.siteId = sessionStorage.getItem('urlSiteId');
            this.contentIndex = this.$route.query.contentIndex;
            this.catalogId = this.$route.query.catalogId;
            this.catalogDetail(this.catalogId);
            this.getPlug();
        }
    },
    destroyed () {
        removeWatermark();
    },
    methods: {
        IsPC () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone',
                'SymbianOS', 'Windows Phone',
                'iPad', 'iPod'];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        catalogDetail (id, siteId) {
            let params = {
                siteId: this.siteId || sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: id,
            };
            api.catalogDetail(params).then((res) => {
                if (res.errcode === 0) {
                    let cataloglist = res.data.list;
                    cataloglist.sort(function (a, b) {
                        return a.rank - b.rank;
                    });
                    cataloglist = cataloglist[this.contentIndex];
                    document.title = cataloglist.title;
                    if (cataloglist.contentType === 0) {
                        this.cataloglist.type = 0;
                        let htm = cataloglist.contentText && cataloglist.contentText.replace(new RegExp('<video', 'g'), '<div class="page-video-container"><video style="opacity: 0.99;object-fit:cover"');
                        htm = htm && htm.replace(new RegExp('</video>', 'g'), '</video></div>');
                        this.cataloglist.htm = htm;
                        this.addVideoEvent();
                    } else if (cataloglist.contentType === 1) {
                        this.cataloglist.type = 1;
                        this.cataloglist.url = cataloglist.contentLink;
                    } else if (cataloglist.contentType === 2) {
                        this.cataloglist.type = 2;
                        this.videoUrl = cataloglist.contentVideo;
                        this.cataloglist.VideoImage = cataloglist.contentVideoImage;
                    }
                    this.iscataloglist = true;
                }
            });
        },
        // 获取插件是否显示
        getPlug () {
            const params = {
                siteId: this.siteId || sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getPageManagePlugList(params).then((res) => {
                if (res.errcode === 0) {
                    let tableData = res.data.list;
                    this.showqq = tableData[0] && tableData[0].useType.includes('1');
                    this.showdz = tableData[1] && tableData[1].useType.includes('1');
                }
            });
        },
        inited (viewer) {
            this.$viewer = viewer;
            this.$viewer.index = this.activeIndex;
            // 不要他的按钮
            this.$viewer.options.button = false;
            // 不要他的底部缩略图
            this.$viewer.options.navbar = false;
            // 不要他的底部标题
            this.$viewer.options.title = false;
            // 不要他的底部工具栏
            this.$viewer.options.toolbar = false;
        },
        // 调用显示
        show () {
            this.$viewer.show();
        },
        imageEnlargement (e) {
            if (e.target.nodeName == 'IMG') { // 判断点击富文本内容为img图片
                // console.log();
                this.photo.push(e.target.currentSrc);
                this.show();
            } else {
                console.log('点击内容不为img');
            }
        },
        // 设置视频封面
        setPoster (e) {
            let ele = e.srcElement;
            // ios终端使用默认视频封面图
            const posterUrl = require('../../../assets/icon/icon_poster.png');
            ele.setAttribute('poster', posterUrl);
        },
        // 添加视频事件
        addVideoEvent () {
            const u = navigator.userAgent;
            const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            // ios终端使用默认视频封面图
            if (isIOS) {
                this.$nextTick(() => {
                    const allaudio = document.querySelectorAll('video') || [];
                    for (let i = 0; i < allaudio.length; i++) {
                        allaudio[i].addEventListener('loadedmetadata', (event) => {
                            this.setPoster(event);
                        });
                    }
                });
            }
        },
        getInfoCintent (id) {
            if (this.$route.query.type) {
                var params = {
                    contentId: id,
                    type: 1,
                };
            } else {
                params = {
                    contentId: id,
                };
            }
            api.getInfoCintent(params).then((res) => {
                if (res.errcode === 0) {
                    // let subStr = /webkit-playsinline=""/g;
                    let data = res.data;
                    data.contentText = data.contentText.replace(`webkit-playsinline=""`, `webkit-playsinline="true"`);
                    data.contentText = data.contentText.replace(`playsinline=""`, `playsinline="true" x5-playsinline=""`);
                    // data.contentText = data.contentText.replaceAll('<video', '<video style="opacity: 0.99;object-fit:cover"');
                    data.contentText = data.contentText && data.contentText.replace(new RegExp('<video', 'g'), '<div class="page-video-container"><video style="opacity: 0.99;object-fit:cover"');
                    data.contentText = data.contentText && data.contentText.replace(new RegExp('</video>', 'g'), '</video></div>');
                    this.urlList = data;
                    this.urlList.marginStatus === 0 ? this.isMargin = false : this.isMargin = true;
                    // console.log('this.urlList.contentText: ', this.urlList.contentText);

                    let type = this.urlList.contentType;
                    this.siteId = res.data.siteId;
                    document.title = this.urlList.title;

                    this.getPlug();
                    this.wxshor();
                    if (res.data.siteStatus === 1) {
                        if (type === 0) {
                            this.html = this.urlList.contentText;
                            this.addVideoEvent();
                        } else if (type === 1) {
                            this.url = this.urlList.contentLink;
                        } else if (type === 2) {
                            this.videoUrl = this.urlList.contentVideo;
                            this.poster = this.urlList.contentVideoImage;
                            this.isvideo = true;
                        }
                    } else {
                        this.siteStatus = true;
                    }
                } else if (res.errcode === 1001) {
                    this.dataDtl = true;
                } else {
                    this.$message.error(res.errmsg);
                }
            }).catch((error) => {
                console.log(error);
            })
            ;
        },
        // 微信分享
        wxshor () {
            console.log(this.urlList);
            let that = this;
            // let url = 'https://market.anoah.com/product01/index.html#/'
            let url = location.href.split('#')[0];
            let params = {
                url: url,
            };
            api.getWxurl(params).then((res) => {
                let data = res.data || {};
                // eslint-disable-next-line no-undef
                wx.config({
                    debug: false, // 是否开启调试模式
                    appId: data.appId, // appid
                    timestamp: data.timestamp, // 时间戳
                    nonceStr: data.nonceStr, // 随机字符串
                    signature: data.signature, // 签名
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareQZone',
                    ], // 需要使用的JS接口列表
                });
                // that.shareimg = that.urlList.images[0];
                // if (that.shareimg == null) {
                //     that.shareimg = 'https://daogouapi.youxuepai.com/file/wechat/img/1125144501611YXPLOGO.png';
                // }
                // eslint-disable-next-line no-undef
                wx.ready(function () {
                    // eslint-disable-next-line no-undef
                    wx.onMenuShareAppMessage({
                        title: that.urlList.title || '优学派', // 分享标题
                        desc: that.urlList.subtitle || '优学派', // 分享描述
                        link: window.location.href, // 分享链接
                        imgUrl: that.urlList.images[0] || 'https://daogouapi.youxuepai.com/file/wechat/img/1125144501611YXPLOGO.png', // 分享图标
                        success: function () {
                            console.log('分享成功');
                        },
                        cancel: function () {
                            console.log('分享失败');
                        },
                    });
                });
            });
        },
        cls () {
            this.showBox = false;
        },
    },
};
</script>
<style lang="scss">
   .htmlBox{
    video{
        min-width: 100% !important;
        margin:0 auto !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    img {
        -webkit-touch-callout: none;
    }
  }
  .page-video-container {
    width: 100%;
    height: 28vh;
    position: relative;
    video {
        width: 100%;
        height: 100%;
    }
  }
</style>
<style lang='scss' scoped>
.data {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // margin-top: 10px;

  width: 100vw;
  height: 100vh;
  .mobileBox {
    width: 450px;
    height: 837px;
    border-radius: 5px;
    border: 1px solid #eee;
  }
  .ifBox {
    width: 100%;
    height: 100%;
  }
  .ifmBox{
    width: 100%;
    height: 100%;
  }
  .ifme {
    width: 100%;
    height: 100%;
  }
  .imgbox {
    display: flex;
    width: 100vw;
    height: auto;
    position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
    .videoImg {

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

    }
    .play_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
    }
  }
}
.videoBox {
    width: 100%;
    height: 28vh;
    position: relative;
    top: 30%;
    video {
      width: 100%;
      height: 100%;
    }
  }

.play_icon {
  width: 60px;
  height: 60px;
  position: relative;
  top: -140px;
  left: 45%;
}
.theVideoStratumBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  width: 100% !important;
}
.data table{
  border: 1px solid #ccc;

}
.data table tbody th{
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    min-height: 30px;
}
.data table tbody td{
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    min-height: 30px;
}
.vdo {
  width: 100%;
}
.ifmebox {
  width: 100%;
  height: 100%;
}
.nodata{
  // width: 50vh;
  height: 39vh;
  position: absolute;
//   top: 30%;
  // display: flex;
  // flex-direction: column;
  // text-align: center;
//   left: 7%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.nodata_text{
    position: absolute;
    top: 90%;
    left: 22%;
  }
.nodata_text2{
    position: absolute;
    top: 90%;
    left: 18%;
  }
.haveMargin{
  padding: 0 10px;
}
</style>
